import React from 'react';
import AdminSearchCosts from '../../components/AdminSearchCosts';
import './Admin.css';

function AdminSearchPage() {
  return (
    <div className="admin-page">
      <h1>Search costs</h1>
      <AdminSearchCosts />
    </div>
  );
}

export default AdminSearchPage;
